import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
  const gutter = theme.new.spacing.medium;
  const contentPadding = theme.new.spacing.xl;

  return {
    layout: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
    },
    header: {
      minHeight: '64px',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.new.color.common.white,
      padding: `0 ${gutter}`,
    },
    // The selector drops below the logo on narrow screens, where the two do not
    // fit side by side, and the header grows to hold both rows.
    headerContent: {
      width: '100%',
      padding: `12px ${contentPadding}`,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      rowGap: '12px',
    },
    localeSelect: {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '260px',
      },
    },
    body: {
      flex: 1,
      padding: `0 ${gutter}`,
    },
    bodyContent: {
      padding: `80px ${contentPadding} 0`,
      [theme.breakpoints.up('md')]: {
        paddingTop: '128px',
        maxWidth: '760px',
      },
    },
    termsAndConditions: {
      margin: `${theme.new.spacing.xl} 0`,
      color: theme.new.color.text.primary,
      background: 'none',
      border: 'none',
      padding: 0,
      font: 'inherit',
      cursor: 'pointer',
      textDecoration: 'underline',
      '@media print': {
        display: 'none',
      },
    },
    footer: {
      borderTop: `1px solid ${theme.new.color.line.hairline}`,
      padding: `0 ${gutter}`,
    },
    footerContent: {
      padding: contentPadding,
      display: 'flex',
      flexDirection: 'column',
      gap: '18px',
    },
    footerLinks: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      color: theme.new.color.text.secondary,
      '& a': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },
  };
});

export default useStyles;
